import { Component, Input } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-tablev2',
  templateUrl: './tablev2.component.html',
  styleUrls: ['./tablev2.component.scss']
})
export class Tablev2Component {
  
  public is_loading = true;
  public is_load = false;
  public disabled_pagenat = false;
  public setting: any = [];
  public content: any = [];
  public summary: any = null;
  public pagenat : {total?: number, current?: number, show_page?: number, per_page?: number, previous?: number, next?: number, pagenat?: [], page_no? : []} = {pagenat: [], page_no: []};
  public no_per_page = null;
  public filter : any = {};
  public row_setting: any = {};
  
  private url;
  private post_data;

  @Input() set setSetting(v:any){
    this.init(v);
  }

  constructor(private http: HttpService) { }

  public filterEnabled() {
    const v = this.setting;
    return v.length > 0 && v.filter(x => x.filter).length > 0 ? true : false;
  }

  public async init(setting) {

    this.is_load = true;

    this.setting = setting.fields;

    if (setting.disabled_pagenat) {
      this.disabled_pagenat = setting.disabled_pagenat;
    }

    if (setting.no_per_page) {
      this.no_per_page = setting.no_per_page;
    }

    if (setting.post.url) {
      this.url = setting.post.url;
    }

    if (setting.post.data) {
      this.post_data = setting.post.data;
    }

    if (setting.row) {
      this.row_setting = setting.row;
    }

    const rtn = await this.load();
    this.pagenat = rtn['pagenat'];
    this.content = rtn['collection'];
    this.summary = rtn['summary'] || null;
  
  }

  public async reload(data = null, page = 0, no_per_page = null) {

    // if (no_per_page) {
    //   this.no_per_page = no_per_page;
    // }

    // if (data) {
    //   this.post_data = data;
    // }
    const rtn = await this.load();
    this.pagenat = rtn['pagenat'];
    this.content = rtn['collection'];
    this.summary = rtn['summary'] || null;

  }

  private async load() {
    const data = this.post_data;
    data.page = this.pagenat;
    data.filter = this.filter;
    this.reset();
    const reply = await this.http.post(this.url, this.post_data);

    this.is_loading = false;

    return reply;
  }

  public async delete(title, table, uuid) {
    var message = confirm("You are about to remove " + title + " from the record. This is not revisable. Are you sure?")

    if (message) {
      const y:any = await this.http.post("/admin/setting/remove/update", {title, table, uuid});

      if(y.status) {
        const rtn = await this.load();

        this.pagenat = rtn['pagenat'];
        this.content = rtn['collection'];
      }
    }
  }

  public async button(action, data) {
    await action(data);
  }

  public async reset() {
    this.content = [];
    this.summary = null;
  }

  public async selectPage(page) {
    this.pagenat.show_page = page
    const rtn = await this.load();
    this.pagenat = rtn['pagenat'];
    this.content = rtn['collection'];
    this.summary = rtn['summary'] || null;
  }

  public async search($data) {
    if ($data.length < 3) {
      return;
    } 
    
    const rtn = await this.load();
    this.pagenat = rtn['pagenat'];
    this.content = rtn['collection'];
    this.summary = rtn['summary'] || null;
  }

  public footerEnabled() {
    return this.summary && this.setting && this.setting.filter(x => x.footer_label || x.footer_key).length > 0;
  }
  
}
